// extracted by mini-css-extract-plugin
module.exports = {"base":"oranism1-m__base__i4tCr","first-story":"oranism1-m__first-story__s1Ign","rest-stories":"oranism1-m__rest-stories__1bZWE"};